import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getLevelUpCompetencyDataApi = ({ employeeId, targetRole = false }) => {
  const url = endpoints.levelUp.competencyData(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      target_role: targetRole,
    },
  });
};

export const setAgendaFromLevelUpPageApi = ({ employeeId, text, status, uiKey }) => {
  const url = endpoints.levelUp.addToAgenda(employeeId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      text,
      status,
      uiKey,
    },
  });
};

export const getLevelUpReporteeDataApi = ({ employeeId }) => {
  const url = endpoints.levelUp.reporteeData(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
